// dependencies
import React from "react";

// components
import Spinner from "../../components/Spinner/ComponentLoader";

const ExtendSessionPage = () => <Spinner>Please wait while we log you in...</Spinner>;

export default ExtendSessionPage;
